import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Sobre() {
  const values = [
    {
      icon: 'ri-eye-line',
      title: 'Transparência',
      description: 'Agimos com clareza e honestidade em todas as nossas relações, construindo confiança genuína.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Vontade',
      description: 'Acreditamos no poder da determinação e do desejo genuíno de transformar vidas.'
    },
    {
      icon: 'ri-arrow-up-line',
      title: 'Inconformismo',
      description: 'Não aceitamos o status quo. Buscamos constantemente evoluir e inovar.'
    },
    {
      icon: 'ri-star-line',
      title: 'Referência',
      description: 'Nos posicionamos como exemplo de excelência em desenvolvimento humano.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Influência',
      description: 'Impactamos positivamente a vida de pessoas e comunidades inteiras.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Transformação',
      description: 'Promovemos mudanças reais e duradouras na vida de cada pessoa.'
    }
  ];

  const timeline = [
    {
      year: '2018',
      title: 'Fundação',
      description: 'Nascimento do Instituto Allcance com o propósito de transformar vidas através da educação.'
    },
    {
      year: '2019',
      title: 'Primeiros Programas',
      description: 'Lançamento dos programas Despertar e Capacita, impactando centenas de vidas.'
    },
    {
      year: '2020',
      title: 'Expansão Digital',
      description: 'Criação da plataforma EAD, democratizando o acesso ao conhecimento.'
    },
    {
      year: '2021',
      title: 'Parcerias Empresariais',
      description: 'Início do programa de encaminhamento ao mercado de trabalho.'
    },
    {
      year: '2022',
      title: 'Geração Valor',
      description: 'Lançamento do programa focado em juventude e liderança comunitária.'
    },
    {
      year: '2023',
      title: 'Reconhecimento',
      description: 'Mais de 5.000 vidas transformadas e reconhecimento nacional.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Sobre o Instituto Allcance
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Uma história de propósito, transformação e impacto social
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6">Nossa História</h2>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                O <strong>Instituto Allcance</strong> nasceu em 2018 do sonho de criar um espaço onde pessoas pudessem descobrir seu verdadeiro potencial e transformar suas vidas através do desenvolvimento pessoal e profissional.
              </p>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                Fundado por educadores e profissionais apaixonados por desenvolvimento humano, o instituto começou com turmas pequenas e um grande propósito: ajudar cada pessoa a <strong>alcançar o futuro que deseja</strong>.
              </p>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                Hoje, somos referência em capacitação profissional e desenvolvimento pessoal, com milhares de vidas transformadas e uma rede crescente de empresas parceiras.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/310a6919afa42d08a22f6ce539d3189a.jpg"
                alt="Equipe fundadora"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Purpose */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-target-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Missão</h3>
              <p className="text-slate-700 leading-relaxed">
                Promover o desenvolvimento integral de pessoas através do autoconhecimento, capacitação profissional e encaminhamento ao mercado de trabalho, criando pontes entre sonhos e realizações concretas.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-700 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Visão</h3>
              <p className="text-slate-700 leading-relaxed">
                Ser referência nacional em desenvolvimento humano e capacitação profissional, reconhecidos pela excelência, impacto social e pela transformação genuína de vidas.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-line text-3xl text-slate-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Propósito</h3>
              <p className="text-slate-700 leading-relaxed">
                Acreditamos que cada pessoa tem um potencial único. Nosso propósito é ajudar a descobrir, desenvolver e direcionar esse potencial para criar um futuro de realizações e significado.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nossos Valores Inegociáveis</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Princípios que guiam cada decisão e ação do Instituto Allcance
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{value.title}</h3>
                <p className="text-slate-700 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nossa Trajetória</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Anos de dedicação e crescimento constante
            </p>
          </div>
          <div className="max-w-4xl mx-auto">
            {timeline.map((item, index) => (
              <div key={index} className="flex gap-8 mb-12 last:mb-0">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg flex-shrink-0">
                    {item.year}
                  </div>
                  {index !== timeline.length - 1 && (
                    <div className="w-1 h-full bg-gradient-to-b from-blue-600 to-purple-600 mt-4"></div>
                  )}
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 flex-1 mb-8">
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                  <p className="text-slate-700 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nosso Impacto</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Números que representam vidas transformadas
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-blue-600 mb-2">+5000</div>
              <p className="text-slate-700 font-semibold">Vidas Transformadas</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-purple-600 mb-2">+150</div>
              <p className="text-slate-700 font-semibold">Empresas Parceiras</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-yellow-500 mb-2">85%</div>
              <p className="text-slate-700 font-semibold">Taxa de Empregabilidade</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-green-600 mb-2">+200</div>
              <p className="text-slate-700 font-semibold">Cursos Realizados</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Compromisso Social</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Acreditamos que educação de qualidade é um direito de todos. Por isso, trabalhamos com bolsas de estudo, parcerias com comunidades e programas de inclusão social para garantir que ninguém fique para trás.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center border border-slate-100">
              <i className="ri-hand-heart-line text-5xl text-blue-600 mb-4"></i>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Bolsas de Estudo</h3>
              <p className="text-slate-700">Oferecemos bolsas integrais e parciais para quem mais precisa</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center border border-slate-100">
              <i className="ri-community-line text-5xl text-purple-600 mb-4"></i>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Parcerias Comunitárias</h3>
              <p className="text-slate-700">Atuamos em comunidades levando educação e oportunidades</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center border border-slate-100">
              <i className="ri-group-line text-5xl text-yellow-500 mb-4"></i>
              <h3 className="text-xl font-bold text-slate-900 mb-3">Inclusão Social</h3>
              <p className="text-slate-700">Programas especiais para grupos em situação de vulnerabilidade</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
